export default {"src":"/_next/static/media/ic_arrow_down_caret_skz.e13e02c7.svg","height":5,"width":10,"blurWidth":0,"blurHeight":0};